import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useLivyAccess } from './access';
import { LivyAvatar } from './LivyAvatar';
import { askLivy } from './LivyGreeting';

/** Points the Reporting page at Livy, only for people Livy is on for; everyone else keeps the page as it was. */
export function LivyReportsBanner() {
  const enabled = useLivyAccess();
  if (!enabled) return null;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      px: '24px',
      pt: '16px'
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    spacing: "12px",
    sx: {
      p: '10px 14px',
      border: 1,
      borderColor: 'divider',
      borderRadius: '12px',
      bgcolor: 'background.paper',
      flexWrap: 'wrap',
      rowGap: '8px'
    }
  }, /*#__PURE__*/React.createElement(LivyAvatar, {
    size: 30
  }), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 14,
      flex: 1,
      minWidth: 200
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Reports have moved to Livy."), " Ask her what you need: any date range, by property, with the raw data to download."), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "contained",
    onClick: () => askLivy(),
    sx: {
      textTransform: 'none',
      borderRadius: '10px'
    }
  }, "Ask Livy")));
}